import { render, staticRenderFns } from "./BigSceen.vue?vue&type=template&id=677f7f4b&scoped=true"
import script from "./BigSceen.vue?vue&type=script&lang=js"
export * from "./BigSceen.vue?vue&type=script&lang=js"
import style0 from "./BigSceen.vue?vue&type=style&index=0&id=677f7f4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f7f4b",
  null
  
)

export default component.exports